<template>
<div class="page-wrapper">
    <div class="container-fluid">

        <!--div class="page-header d-print-none">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col">
                <h2 class="page-title">
                  Inbox
                </h2>
              </div>
            </div>
          </div>
        </div-->

        <div class="page-body">
            <div class="container-fluid">

                <div class="card flex-fill">
                    <div v-if="loading" className="inline ? '' : 'page-wrapper'" class="position-relative">
                        <div class="progress progress-sm position-absolute w-100">
                            <div class="progress-bar progress-bar-indeterminate"></div>
                        </div>
                    </div>

                    <div class="row g-0 flex-fill">
                        <div class="col-12 col-lg-5 col-xl-3 border-end d-flex flex-column">
                            <div class="card-header d-none d-md-block">
                                <div class="input-icon">
                                    <span class="input-icon-addon">
                                        <icon icon="search" height="24" class="icon-1 d-block"></icon>
                                     </span>
                                    <input type="text" value="" class="form-control" placeholder="Search…" v-model="search" aria-label="Search">
                                </div>
                            </div>
                            <div class="card-body p-0 scrollable flex-fill">
                                <div class="nav flex-column nav-pills" role="tablist">
                                    <!-- bg-body-secondary -->
                                    <div v-for="item in items" :key="item.id" @click="() => select(item)" data-bs-toggle="pill" role="tab" aria-selected="false" tabindex="-1" :className="'nav-link cursor-pointer text-start mw-100 p-3 ' + (detail && item.id === detail.id ? 'bg-body-secondary' : '')">
                                        <div class="row align-items-center flex-fill">
                                            <div class="col-auto">
                                                <span class="avatar avatar-1">{{item.title.substring(0,2).toUpperCase() }}</span>
                                            </div>
                                            <div class="col text-body">
                                                <div>{{ item.title }}</div>
                                                <div class="text-secondary text-truncate w-100 small">{{ item.url }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button class="btn btn-primary w-100" @click="create">
                                    <icon icon="plus"></icon>
                                    <span>Create</span>
                                </button>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 col-xl-9 d-flex flex-column">
                            <div class="scrollable" v-if="detail">
                                <div class="card-header">
                                    <div class="form-label mb-0"></div>
                                    <ul class="nav nav-tabs card-header-tabs">
                                        <li class="nav-item" @click="page = ''">
                                            <a :className="'nav-link cursor-pointer ' + (page == '' ? 'active' : '')">
                                                Avatar
                                            </a>
                                        </li>
                                        <li class="nav-item" @click="page = 'settings'">
                                            <a :className="'nav-link cursor-pointer ' + (page == 'settings' ? 'active' : '')">
                                                Settings
                                            </a>
                                        </li>
                                        <li class="nav-item" @click="page = 'share'">
                                            <a :className="'nav-link cursor-pointer ' + (page == 'share' ? 'active' : '')">
                                                Share
                                            </a>
                                        </li>
                                        <li class="nav-item ms-auto">
                                            <a class="nav-link cursor-pointer" @click="$refs.menu.open($event, detail)">
                                                <icon icon="arrow-down"></icon>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-body" v-if="page == 'settings'">
                                    <div class="row mb-3">
                                        <label class="col-md-3 col-form-label">Knowledge Base</label>
                                        <div class="col">
                                            <select class="form-select" v-model="detail.knowledge_id">
                                                <option v-for="know in knowledges" :key="know.id" :value="know.id">{{ know.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <label class="col-md-3 col-form-label">Voice</label>
                                        <div class="col">
                                            <div class="input-group">
                                                <select class="form-select" v-model="detail.voice_id">
                                                    <option v-for="voice in filteredVoices" :key="voice.id" :value="voice.id">{{ voice.title }}</option>
                                                </select>
                                                <button type="submit" class="btn btn-outline-primary" :disabled="loading" @click="previewAudio">Preview</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3 ">
                                        <label class="col-md-3 col-form-label">Title</label>
                                        <div class="col">
                                            <input type="text" class="form-control" placeholder="" required v-model="detail.title">
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <label class="col-md-3 col-form-label">Language</label>
                                        <div class="col">
                                            <select class="form-select" v-model="detail.language">
                                                <option v-for="language in languages" :key="language.id" :value="language.code">{{ language.title }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <label class="col-md-3 col-form-label">Push To Talk</label>
                                        <div class="col">
                                            <label class="form-check">
                                                <input type="checkbox" class="form-check-input" v-model="detail.push_to_talk">
                                                <span class="form-check-label">Require holding the microphone button while speaking</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb-3 ">
                                        <label class="col-md-3 col-form-label">Max session length<div class="small text-secondary">In seconds - leave empty for no limit</div></label>
                                        <div class="col">
                                            <input type="text" class="form-control" placeholder="" required v-model="detail.max_session_length">
                                        </div>
                                    </div>

                                    <div class="d-flex">
                                        <button type="submit" class="btn btn-primary ms-auto" :disabled="loading" @click="update">Update</button>
                                    </div>
                                </div>
                                <div class="card-body" v-else-if="page == 'share'">

                                    <div class="row mb-3">
                                        <div class="col-md-3"><div>Share URL</div></div>
                                        <div class="col-md-9">

                                            <div class="input-group">
                                                <input :value="'https://' + detail.url" readonly  class="form-control" />
                                                <a :href="'https://' + detail.url" target="_blank" type="submit" class="btn btn-outline-primary" :disabled="loading">Open</a>
                                            </div>

                                            </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3"><div>Share widget</div></div>
                                        <div class="col-md-9"><textarea rows="8" :value='"<iframe allow=\"camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;\"\n"+
"    src=\"https://" + detail.url + "\"\n"+
"    height=\"720\" width=\"1280\" frameBorder=\"0\"\n"+
"    style=\"max-width: 100%; height: auto; aspect-ratio: 16/9;\"></iframe>"' readonly  class="form-control"></textarea></div>
                                    </div>

                                </div>
                                <div class="card-body overflow-auto pb-3" style="max-height: calc(100vh - 160px)" v-else>
                                    <div class="row row-cards">
                                        <div class="col-6 col-md-3" v-for="avatar in avatars" :key="avatar.id">
                                            <div :class="'card position-relative ' + (detail.avatar_id === avatar.id ? 'card-active' : '')" @click.prevent="changeAvatar(avatar)">
                                                <div class="card-body p-0">
                                                    <img :src="avatar.preview_image_url" class="avatar-image object-cover"/>
                                                </div>
                                                <div v-if="detail.avatar_id === avatar.id" class="position-absolute w-100 h-100 m-0 bg-primary opacity-50 backdrop-blur">
                                                </div>
                                                <div class="position-absolute avatar-name">
                                                    <div class="badge bg-secondary-lt opacity-80">{{ avatar.title }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body" v-else>

                                <div class="container-tight py-4">
                                    <div class="empty">
                                        <p class="empty-title">Widgets</p>
                                        <p class="empty-subtitle text-muted">
                                            Start by choosing an existing widget or creating a new one
                                        </p>
                                        <div class="empty-action">
                                            <button class="btn btn-primary" @click="create">
                                                <icon icon="plus"></icon>
                                                <span>Create</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <prompt ref="create" title="Widget Name"></prompt>
    <confirm ref="delete" title="Are you sure?"></confirm>

    <context-menu
        ref="menu"
        location="bottom right"
        :items="[{ title: 'Delete', callback: this.deleteItem, class: 'text-danger' }]">
    </context-menu>
</div>
</template>

<script>
import api from "@/common/api";
import Prompt from "@/components/Prompt.vue";
import Confirm from "@/components/Confirm.vue";
import ContextMenu from "@/components/ContextMenu.vue";

export default {
    components: {
        ContextMenu,
        Confirm,
        Prompt

    },
    computed: {
        filteredVoices() {
            if (this.detail && this.detail.avatar_id) {
                const avatar = this.avatars.find(a => a.id === this.detail.avatar_id);
                if (avatar && avatar.gender) {
                    return this.voices.filter(v => v.gender === avatar.gender);
                }
            }
            return this.voices;
        }
    },
    data() {
        return {
            loading: false,
            search: "",
            page: "",
            knowledges: [],
            voices: [],
            languages: [],
            avatars: [],

            items: [],
            detail: null
        };
    },
    watch: {
        search() {
            this.load();
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        changeAvatar(avatar) {
            this.detail.avatar_id = avatar.id;
            this.update();
        },
        select(item) {
            this.detail = JSON.parse(JSON.stringify(item));
            this.detail.push_to_talk = !!this.detail.push_to_talk;

            // sort avatars so that selected one is first and other sort by default
            this.avatars.sort((a, b) => {
                if (this.detail.avatar_id === a.id) {
                    return -1;
                } else if (this.detail.avatar_id === b.id) {
                    return 1;
                }
                return 0;
            });
        },
        deleteItem(item) {
            this.$refs.delete.open(() => {
                this.loading = true;
                api.widgetsDelete(item.id).then(data => {
                    this.loading = false;
                    this.detail = null;
                    this.load();
                }).catch(e => {
                    this.flashError(e);
                    this.loading = false;
                });
            });
        },
        update() {
            this.loading = true;
            api.widgetsUpdate(this.detail).then(data => {
                this.loading = false;
                this.load();
            }).catch(e => {
                this.flashError(e);
                this.loading = false;
            });
        },
        previewAudio() {
            this.voices.forEach(v => {
                if (v.id === this.detail.voice_id) {
                    const voicePreviewExec = new Audio(v.audio_preview_url);
                    voicePreviewExec.play();
                }
            });
        },
        create() {
            this.$refs.create.open("", (item, close) => {
                this.loading = true;
                api.widgetsCreate({ title: item }).then(data => {
                    this.loading = false;
                    this.load();
                    close();
                }).catch(e => {
                    this.flashError(e);
                    this.loading = false;
                });
            });
        },
        load() {
            this.loading = true;
            api.widgets({ search: this.search }).then(data => {
                this.loading = false;
                this.items = data.items;
            }).catch(e => {
                this.flashError(e);
                this.loading = false;
            });

            api.knowledge({}).then(data => {
                this.knowledges = data.items;
            });

            api.voices({}).then(data => {
                this.voices = data.items;
            });

            api.avatars({}).then(data => {
                this.avatars = data.items;
            });

            api.languages({}).then(data => {
                this.languages = data.items;
            });
        }
    }
};
</script>

<style>
.avatar-name {
    right: 0rem;
    bottom: 0rem;

    .badge {
        border-radius: 5px 0 0 0;
    }
}
.avatar-image {
    display: block;
    aspect-ratio: 1/1;
    object-fit: contain;
    width: 100%;
    height: 100%;
}
</style>
